import { render, staticRenderFns } from "./InspirationsCards.vue?vue&type=template&id=7b5a68ae&"
import script from "./InspirationsCards.vue?vue&type=script&lang=js&"
export * from "./InspirationsCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports